import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { status as AppointmentStatus } from '@spike/appointment-model';
import { OrderItems } from '@spike/order-model';
import PetModel from '@spike/pet-model';
import PetCard from 'components/UI/PetCard';
import { FunctionComponent, useMemo } from 'react';
import AddOnServiceItem from './AddOnServiceItem';
import AppointmentItem from './AppointmentItem';
import CustomItem from './CustomItem';
import ExpandableSection from './ExpandableSection';
import ProductItem from './ProductItem';

export interface PetProps {
    pet: PetModel;
    petOrderItems: OrderItems;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        petCard: {
            marginBottom: 10
        }
    })
);

export const Pet: FunctionComponent<PetProps> = props => {
    const classes = useStyles(props);

    const header = (
        <PetCard
            pet={props.pet}
            className={classes.petCard}
        />
    );

    return (
        <ExpandableSection
            header={header}
            initExpanded={true}
            bottomPadding={0}
            className={props.className}
        >
            {props.petOrderItems.appointments
                .filter(
                    item =>
                        ![AppointmentStatus.CANCELLED, AppointmentStatus.DECLINED, AppointmentStatus.NO_SHOW].includes(
                            item.appointment.status.id
                        )
                )
                .map(item => (
                    <AppointmentItem
                        key={item.orderItem.id}
                        appointmentItem={item}
                    />
                ))}
            {props.petOrderItems.addOnServices.map(item => (
                <AddOnServiceItem
                    key={item.orderItem.id}
                    addOnServiceItem={item}
                />
            ))}
            {props.petOrderItems.products.map(item => (
                <ProductItem
                    key={item.orderItem.id}
                    productItem={item}
                />
            ))}
            {props.petOrderItems.customs.map(item => (
                <CustomItem
                    key={item.orderItem.id}
                    customItem={item}
                />
            ))}
        </ExpandableSection>
    );
};

export default Pet;
